import { MenuItemWrap } from '../useMenuUrl';
import { SubMenuBody } from './SubMenuBody';

type Props = {
  onClose: () => void;
};

export const SubMenuCompliance = (props: Props) => {
  const { onClose } = props;
  return (
    <SubMenuBody>
      <MenuItemWrap menuId='cra' onClick={onClose} type='menu' />
      <MenuItemWrap menuId='ppwr' onClick={onClose} type='menu' />
    </SubMenuBody>
  );
};
